import PaymentStore from './PaymentStore.vue';
export default {
  PaymentStore,
};
